import styled from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';
import { ArrowPlacement, BackdropFilter, Border, Fill, FillWithAlpha } from './themeDefinitions';
import { TooltipProps } from './types';

/**
 * Arrow component to be used in tooltips. Supports four directions of placement.
 */
export const Arrow = styled('div')<Pick<TooltipProps, 'opacity'>>(({ opacity }) =>
  css((theme) => ({
    backgroundColor: Fill,
    position: 'absolute',
    width: '8px',
    height: '8px',
    border: 1,
    borderColor: Border,
    transformOrigin: 'center',
    clipPath: 'polygon(0 0, 100% 0, 100% 100%)',
    ["&[data-placement*='top']" as string]: {
      bottom: ArrowPlacement(theme),
      transform: 'rotate(135deg)',
    },
    ["&[data-placement*='right']" as string]: {
      left: ArrowPlacement(theme),
      transform: 'rotate(-135deg)',
    },
    ["&[data-placement*='bottom']" as string]: {
      top: ArrowPlacement(theme),
      transform: 'rotate(-45deg)',
    },
    ["&[data-placement*='left']" as string]: {
      right: ArrowPlacement(theme),
      transform: 'rotate(45deg)',
    },
    // We check for backdrop-filter here to keep its translucent background
    // logic in sync with TooltipContentWrapper, but we don't actually
    // apply a backdrop-filter in the arrow as it picks up the wrapper's
    // shadow and becomes too dark.
    ...(BackdropFilter(theme) && {
      [`@supports (backdrop-filter: ${BackdropFilter(theme)})`]: {
        backgroundColor: FillWithAlpha(opacity),
      },
    }),
  })),
);
